import { render } from "./ProductPopup.vue?vue&type=template&id=542045f1&scoped=true"
import script from "./ProductPopup.vue?vue&type=script&lang=js"
export * from "./ProductPopup.vue?vue&type=script&lang=js"

import "./ProductPopup.scss?vue&type=style&index=0&lang=scss&external"
import "./ProductPopup.vue?vue&type=style&index=1&id=542045f1&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542045f1"]])

export default __exports__